exports.LANGUAGE = {
  en: 'ENGLISH',
  ja: '日本語',
  ko: ' 한국어',
  'zh-cn': '',
  'zh-Hans': '',
  'zh-Hant': '繁體中文',
  'zh-tc': '',
  it: '',
  in: '',
  id: '',
  es: 'ESPAÑOL',
  pt: 'PORTUGUÊS',
  de: 'DEUTSCH',
  fr: 'FRANÇAIS',
  ru: 'РУССКИЙ',
  th: 'ไทย'
};
exports.LANGUAGE_NAME = {
  en: '英文',
  'zh-cn': '简体中文',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁体中文',
  'zh-tc': '繁体中文',
  ja: '日语',
  ko: '韩语',
  th: '泰语',
  it: '意大利语',
  in: '印度尼西亚语',
  id: '印度尼西亚语',
  es: '西班牙',
  ru: '俄语',
  de: '德语',
  fr: '法语',
  pt: '葡萄牙语'
};
exports.XIGUA_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'zh-Hant',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  it: 'it',
  id: 'in',
  es: 'es',
  ru: 'ru',
  de: 'de',
  fr: 'fr',
  'zh-Hant': 'zh-Hant',
  in: 'in',
  pt: 'pt'
};

exports.ZT_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'cht',
  ja: 'jp',
  ko: 'kor',
  th: 'th',
  it: 'it',
  id: 'id',
  es: 'spa',
  ru: 'ru',
  de: 'de',
  fr: 'fra',
  'zh-Hant': 'cht',
  in: 'id',
  pt: 'pt'
};

/**
 *
 * zho（简体中文）
 * eng（英文）
 * zho-tw（台湾）
 * zho-hk（香港）
 * udm（维吾尔语）
 * jpn（日文）
 * ind（印尼）
 * kor（韩语）
 * rus（俄语）
 * ara（阿拉伯语）
 * spa（西班牙语）
 * pon（巴西葡语）
 * por（欧洲葡语）
 * fra（法语）
 * deu（德语）
 * @type {{de: string, 'zh-HANT': string, ru: string, ko: string, th: string, ja: string, en: string, it: string, id: string, fr: string, es: string}}
 */
exports.GEETEST_LANGUAGE = {
  en: 'eng',
  'zh-cn': 'zho',
  'zh-Hans': 'zho',
  'zh-tc': 'zho-hk',
  ja: 'jpn',
  ko: 'kor',
  th: 'eng',
  it: 'eng',
  id: 'ind',
  es: 'spa',
  ru: 'rus',
  de: 'deu',
  fr: 'fra',
  'zh-Hant': 'zho-hk',
  in: 'ind',
  pt: 'por'
};

exports.TDK = {
  en: {
    title: 'Mecha BREAK Official Website — Global Storm Open Beta on Feb 23rd',
    keywords: 'Mecha Break, Mecha Break Pre-Registeration, Mech Games, Si-fi Games, Shooting Games, Action Games',
    description:
      'Mecha BREAK is a multiplayer mech game that offers players a wide array of customizable mechs. Battle  colossal war machines across treacherous terrain. Brace yourself for the ultimate showdown—blitz, brawl, and blaze!'
  },
  ja: {
    title: '「Mecha BREAK」公式サイト ― 2月23日 GLOBAL STORM STEAM DEMO テスト開始',
    keywords: 'Mecha BREAK、Mecha BREAK事前登録、メカゲーム、SFゲーム、シューティングゲーム、アクションゲーム',
    description:
      'チカラ！スピード！一斉砲火！『Mecha BREAK』は、人型機動兵器のMB（メカブレイク）を操縦して戦うマルチオンラインTPS対戦ゲームで、多彩な機体を操り、弾丸が飛び交い、パワフル感溢れる立体的戦闘を楽しんでいただけます！'
  },
  ko: {
    title: '<Mecha BREAK> 공식 사이트 — 2월 23일 글로벌 스톰 오픈 베타 테스트 출시',
    keywords: '메카 브레이크, 메카 브레이크 사전예약, 메카 게임, SF 게임, 슈팅 게임, 액션 게임',
    description:
      // eslint-disable-next-line quotes
      '<Mecha BREAK>는 근미래 공상과학 장르를 바탕으로 멀티플레이가 가능한 메카 전투 게임입니다. 각각의 독특한 전투 스타일을 갖춘 메카를 활성화하고, 메카의 외형을 커스터마이징하여 험난한 지형에서 거대 로봇들과 대항해 보세요.  '
  },
  'zh-Hant': {
    title: '《Mecha BREAK》官網 — 2月23日 全球風暴 測試開始',
    keywords: 'Mecha BREAK，Mecha BREAK預約，機甲遊戲，科幻遊戲，射擊遊戲、動作遊戲',
    description:
      '力量！速度！密集的火力覆蓋！《Mecha BREAK》是一款近未來科幻機甲主題的多人對戰遊戲。在這款機甲動作射擊遊戲中，你將駕駛作戰風格各異的機甲，感受動力澎湃、火力全開的立體空間戰鬥。'
  },
  es: {
    title: 'Sitio Oficial de Mecha BREAK — Beta Pública Global Storm en 23 de febrero',
    keywords: 'Mecha Break, preinscripción en Mecha Break, juegos de mechas, juegos de ciencia ficción, juegos de disparos, juegos de acción',
    description:
      'Mecha BREAK es un juego de mechas multijugador en el que puedes elegir entre varios robots personalizables. Lucha contra colosales máquinas de guerra en un terreno traicionero. ¡Prepárate para la gran batalla con bombardeos, embestidas y disparos!'
  },
  pt: {
    title: 'Site Oficial de Mecha BREAK — Beta Aberto de Global Storm em 23 de Fevereiro',
    keywords: 'Mecha Break, pré-registro do Mecha Break, jogos de mecha, jogos de ficção, jogos de tiro, jogos de ação',
    description:
      'Mecha BREAK é um jogo multijogador que oferece uma enorme variedade de mechas que podem ser personalizados. Trave batalhas imensas com máquinas de guerra em terrenos traiçoeiros. Prepare-se para o confronto supremo com bombardeamento, pancadaria e fogo!'
  },
  de: {
    title: 'Offizielle Webseite von Mecha BREAK - Globaler Sturm Offene Beta am 23. Februar',
    keywords: 'Mecha Break, Mecha Break Vorregistrierung, Mech-Spiele, Sci-Fi-Spiele, Shooter-Spiele, Actionspiele',
    description:
      'Mecha BREAK ist ein Multiplayer-Mecha-Spiel, das den Spielern eine Vielzahl von anpassbaren Mechas bietet. Kämpfe gegen kolossale Kriegsmaschinen auf tückischem Terrain. Mach dich bereit für den ultimativen Showdown – Blitz, Krach und Boom!'
  },
  fr: {
    title: 'Site Officiel de Mecha BREAK — Béta Publique Global Storm au 23 février',
    keywords: "Mecha BREAK, préinscription Mecha BREAK, jeux de mecha, jeux de SF, jeux de tir, jeux d'action",
    description:
      "Mecha BREAK est un jeu multijoueur qui permet de choisir parmi différents mechas, de personnaliser leur apparence et de se mesurer à des machines de guerre colossales sur des terrains dangereux. Préparez-vous à l'affrontement ultime : bombardez, brutalisez, brûlez !"
  },
  ru: {
    title: 'Mecha BREAK Официальный сайт — Открытый бета-тест Global Storm начинается 23 февраля',
    keywords: 'Mecha Break, предварительная регистрация Mecha Break, игры про мехов, фантастические игры, шутеры, экшены',
    description:
      'Mecha BREAK – многопользовательская игра, где можно выбрать одного из разнообразных мехов, настроить его облик по своему вкусу и вступить в схватку с огромными боевыми машинами в наполненных опасностями локациях. Приготовьтесь к бескомпромиссному противостоянию!'
  },
  th: {
    title: 'Mecha BREAK เว็บไซต์ทางการ —  Global Storm Open Beta จะเริ่มใน 23 กุมภาพันธ์ นี้',
    keywords: 'Mecha BREAK，Mecha BREAK official site，Mecha BREAK Pre-Register，เกมหุนรบ，เกมไซไฟ，เกมชูตติ้ง、เกมแอ็กชัน',
    description:
      ' 《Mecha BREAK》 เกมแอคชั่นมัลติเพลเยอร์ที่พาคุณเข้าสู่การต่อสู้ของ Striker หุ่นรบสุดล้ำ ในฐานะ Pilot คุณจะได้ควบคุม Striker หลากสไตล์ พร้อมสัมผัสการต่อสู้สามมิติในอวกาศที่เต็มไปด้วยพลังและการยิงกระหน่ำแบบจัดเต็ม!'
  }
};
// 长链： //mechabreak.seasungames.com/p/m/2024/12/19/dlc/ 短链：//mechabreak.seasungames.com/m/
const pcTest = '//test-zt.xoyo.games/mechabreak.seasungames.com/p/m/2024/12/19/dlc/';
const pcMaster = '//mechabreak.seasungames.com/m/';
exports.PC_ADDRESS = {
  en: {
    testUrl: pcTest + 'en/',
    masterUrl: pcMaster + 'en/'
  },
  ja: {
    testUrl: pcTest + 'ja/',
    masterUrl: pcMaster + 'ja/'
  },
  ko: {
    testUrl: pcTest + 'ko/',
    masterUrl: pcMaster + 'ko/'
  },
  'zh-Hant': {
    testUrl: pcTest + 'zh-Hant/',
    masterUrl: pcMaster + 'zh-Hant/'
  },
  es: {
    testUrl: pcTest + 'es/',
    masterUrl: pcMaster + 'es/'
  },
  pt: {
    testUrl: pcTest + 'pt/',
    masterUrl: pcMaster + 'pt/'
  },
  de: {
    testUrl: pcTest + 'de/',
    masterUrl: pcMaster + 'de/'
  },
  fr: {
    testUrl: pcTest + 'fr/',
    masterUrl: pcMaster + 'fr/'
  },
  ru: {
    testUrl: pcTest + 'ru/',
    masterUrl: pcMaster + 'ru/'
  },
  th: {
    testUrl: pcTest + 'th/',
    masterUrl: pcMaster + 'th/'
  }
};

exports.PROTOCOL = {
  en: {
    appointment: '//www.mechabreak.com/show-1034-38-1.html',
    cookie: '//www.mechabreak.com/show-1031-35-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=en&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=en&gamecode=111111681'
  },
  ja: {
    appointment: '//www.mechabreak.com/show-1031-41-1.html',
    cookie: '//www.mechabreak.com/show-1031-36-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=ja-1&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=ja-1&gamecode=111111681'
  },
  ko: {
    appointment: '//www.mechabreak.com/show-1031-40-1.html',
    cookie: '//www.mechabreak.com/show-1031-37-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=ko-1&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=ko-1&gamecode=111111681'
  },
  'zh-Hant': {
    appointment: '//www.mechabreak.com/show-1031-39-1.html',
    cookie: '//www.mechabreak.com/show-1031-34-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=zh-Hant-1&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=zh-Hant-1&gamecode=111111681'
  },
  es: {
    appointment: '//www.mechabreak.com/show-1094-146-1.html',
    cookie: '//www.mechabreak.com/show-1094-147-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=es&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=es&gamecode=111111681'
  },
  pt: {
    appointment: '//www.mechabreak.com/show-1095-153-1.html',
    cookie: '//www.mechabreak.com/show-1095-152-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=pt&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=pt&gamecode=111111681'
  },
  de: {
    appointment: '//www.mechabreak.com/show-1096-157-1.html',
    cookie: '//www.mechabreak.com/show-1096-156-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=de&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=de&gamecode=111111681'
  },
  fr: {
    appointment: '//www.mechabreak.com/show-1097-161-1.html',
    cookie: '//www.mechabreak.com/show-1097-160-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=fr&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=fr&gamecode=111111681'
  },
  ru: {
    appointment: '//www.mechabreak.com/show-1098-165-1.html',
    cookie: '//www.mechabreak.com/show-1098-164-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=ru&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=ru&gamecode=111111681'
  },
  th: {
    appointment: '//mechabreak.seasungames.com/show-1238-242-1.html',
    cookie: '//mechabreak.seasungames.com/show-1034-324-1.html',
    privacy: '//www.amazingseasun.com/privacy.html?lang=th&gamecode=111111681',
    service: '//www.amazingseasun.com/user.html?lang=en&gamecode=111111681'
  }
};
/**
 * message的cms id
 * @type {{de: number, 'zh-Hant': number, ru: number, pt: number, th: number, ja: number, kr: number, en: number, fr: number, es: number}}
 */
exports.MESSAGE_CMS_ID = {
  en: 1223,
  de: 1224,
  es: 1225,
  fr: 1226,
  ja: 1227,
  ko: 1228,
  pt: 1229,
  ru: 1230,
  'zh-Hant': 1231,
  th: 1232
};
